/**
 * 把 2FA 動態碼整理成後端要的 6 位字串。
 *
 * 這裡刻意回傳 string 而不是 number —— 以前各頁都寫 `code: Number(code)`,
 * 「015273」送出去就變成 15273,後端 speakeasy 第一關就在比長度(5 !== 6),
 * 直接判定失敗。使用者輸入完全正確,卻看到「Token驗證失敗」,只能重登碰運氣。
 * 開頭是 0 的碼大約十分之一,所以踩中的頻率相當高。
 */
export const normalizeOtp = (code: unknown): string =>
  String(code ?? '').replace(/\D/g, '');
